import { createFileRoute, Outlet } from '@tanstack/react-router';
import MobileAppLayout from '@/app/sales-channels/mobile-app/layout';

export const Route = createFileRoute('/sales-channels/mobile-app')({
  component: RouteLayout,
});

function RouteLayout() {
  return (
    <MobileAppLayout>
      <Outlet />
    </MobileAppLayout>
  );
}
